import LostAccessModalImage from 'assets/images/dashboard/LostAcessImage.svg';
import { Modal, Grid, Button, Typography } from '@mui/material';
import { Box } from '@mui/system';
import PerfectScrollbar from 'react-perfect-scrollbar';

const LostAccessModal = () => {
    const style = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        // bgcolor: 'background.paper',
        boxShadow: 24
    };

    return (
        <Box className="modal-box modal modalLarge" sx={style}>
            <PerfectScrollbar style={{ maxHeight: '80vh' }}>
                <Box className="modal-body">
                    <Grid container justifyContent={'space-between'}>
                        <Grid item xs={12} sm={6}>
                            <Typography variant="h2" component="h2" className="title-modal-upgrade">
                                Uh oh, you’ve lost access
                            </Typography>
                            <Typography variant="p" component="p" className="subtitle-modal-upgrade">
                                Your company's Premium plan has been downgraded to the free plan, which only allows access to Diolog for the
                                first 2 members. The remaining members will lose access.
                            </Typography>
                            <Typography variant="p" component="p" className="subtitle-modal-upgrade">
                                Please contact your company admin for more information.
                            </Typography>
                        </Grid>
                        <Grid
                            item
                            sx={{
                                display: { xs: 'none', sm: 'block' }
                            }}
                            sm={6}
                            mt={7}
                        >
                            <img src={LostAccessModalImage} alt="lost-acess-modal" className="float-right" />
                        </Grid>
                    </Grid>
                </Box>
            </PerfectScrollbar>
        </Box>
    );
};
export default LostAccessModal;
